<template>
  <span>{{ t(`NotificationsComponent.${props.notification.type}`, { carbonitePlan: notificationMessage }) }}</span>
</template>

<script setup lang="ts">
import { PropType, ref } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { INotification } from "@/stores/notifications";

const componentName = "AutoRenewTurnOnSuccessNotification";

const props = defineProps({
  notification: {
    type: Object as PropType<INotification>,
    required: true,
  },
});

logEvent("created", componentName);

const notificationMessage = ref<string>(props.notification?.params?.carbonitePlan ?? "");
</script>
